
import {
  Grid,
  Typography,
} from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { UserSelector } from '../../store/User'
import { HighlightCard } from '../../components/Cards'
import {
  CommunityOutlinedIcon,
  LightbulbOutlinedIcon,
  BeakerOutlinedIcon,
  WaterUtilityOutlinedIcon,
} from '../../components/icons'
import { useEffect } from 'react'
import { PersonalRecommendationsCard, UserGreetingCard } from './Components'
import { YourHomeProfileCard } from './Components/YourHomeProfileCard'

export const OverviewPage = () => {
  const navigate = useNavigate()
  const user = useSelector(UserSelector.user)
  const resultsRoute = user?.stripVersion === 'v2' ? '/profile/results-v2' : '/profile/results'
  useEffect(() => {

  }, [])
  return (
    <>
    <Grid sx={{
      py: 4,
      px:{xs:0.5, md: 2},
      width: '100%',
      background: 'white' }} container direction="column">
      <Typography variant="h4">Overview</Typography>
      {/*Greeting*/}
        <UserGreetingCard/>
      {/*Your Home Profile — equipment + latest test snapshot*/}
      <Grid sx={{ mt: 2 }}>
        <YourHomeProfileCard/>
      </Grid>
      {/*Personal Recommendations*/}
      <PersonalRecommendationsCard/>
      <Grid sx={{ p: 3 }}>
        <Typography variant="h4"> Water Quality intelligence report</Typography>
        <Typography variant="body1">Access your water analysis tools and insights</Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: '8px' }} >
          <HighlightCard
            actionIcon={<LightbulbOutlinedIcon />}
            contentHeader="Personal recommendations"
            contentText="Get tailored water improvement suggestions based on your test results"
            status="success"
            onClickAction={() => navigate('/profile/recommendations')}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: '8px' }}>
          <HighlightCard
            actionIcon={<BeakerOutlinedIcon />}
            contentHeader="Test Strip Results"
            contentText="View detailed analysis of your latest water quality tests"
            status="secondary"
            onClickAction={() => navigate(resultsRoute)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: '8px' }}>
          <HighlightCard
            actionIcon={<WaterUtilityOutlinedIcon />}
            contentHeader="Utility breakdown"
            contentText="Understand your municipal water system and compliance data"
            status="warning"
            onClickAction={() => navigate('/profile/info')}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: '8px' }}>
          <HighlightCard
            actionIcon={<CommunityOutlinedIcon />}
            chipProps={{
              label: 'Coming Soon',
              variant: 'outlined-neutral',
            }}
            contentHeader="Community Insights"
            contentText="Compare your water quality with neighbors and local trends"
            status="error"
            onClickAction={() => navigate('/profile/community')}
          />
        </Grid>
      </Grid>
    </Grid>
    </>
  )
}
